exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-form-sync{font-size:1rem}.fts-form-sync .fts-form-sync__trigger{display:flex}.fts-form-sync .form-sync-icon{color:var(--fts-default)}.fts-form-sync .form-sync-icon.form-sync-icon--success{color:var(--fts-success)}.fts-form-sync .form-sync-icon.form-sync-icon--error{color:var(--fts-danger)}.fts-form-sync .form-sync-wrapper{display:flex;align-items:center}.fts-form-sync .form-sync-action{margin-left:.25rem;font-size:.875rem;line-height:1rem;color:var(--fts-default);cursor:pointer}.fts-form-sync .form-sync-action:hover{color:var(--fts-primary)}", ""]);

// exports
